import { cubicBezier } from '../internal';
export var easeOut = cubicBezier(0, 0, .58, 1);
